// Just a page that shows a message saying the booking request was sent

// MUI IMPORTS
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

//THE ACTUAL PAGE
export const BookingError = () => {
  const navigate = useNavigate();

  return (
    <div className="page">
      <Typography variant="h4">
        "There was a problem sending your booking info. Please give us a call at
        519-596-2523, or email mail@landsendpark.com"
      </Typography>
      <Button variant="outlined" onClick={() => navigate("/")}>
        Back to home page
      </Button>
    </div>
  );
};
